import { createNotificationQueueStore } from '@/store/createNotificationQueueStore'

export { type INotificationQueueItem } from '@/store/createNotificationQueueStore'

export const useAnnouncementModalsStore =
  createNotificationQueueStore('announcementModals')
